"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var ObjectExpressionKeysTransformer_1;
Object.defineProperty(exports, "__esModule", { value: true });
const inversify_1 = require("inversify");
const ServiceIdentifiers_1 = require("../../container/ServiceIdentifiers");
const estraverse = __importStar(require("estraverse"));
const TransformationStage_1 = require("../../enums/node-transformers/TransformationStage");
const AbstractNodeTransformer_1 = require("../AbstractNodeTransformer");
const NodeGuards_1 = require("../../node/NodeGuards");
const NodeStatementUtils_1 = require("../../node/NodeStatementUtils");
const ObjectExpressionExtractor_1 = require("../../enums/node-transformers/converting-transformers/properties-extractors/ObjectExpressionExtractor");
let ObjectExpressionKeysTransformer = ObjectExpressionKeysTransformer_1 = class ObjectExpressionKeysTransformer extends AbstractNodeTransformer_1.AbstractNodeTransformer {
    constructor(objectExpressionExtractorFactory, randomGenerator, options) {
        super(randomGenerator, options);
        this.objectExpressionExtractorFactory = objectExpressionExtractorFactory;
    }
    static isProhibitedHostStatement(objectExpressionNode, hostStatement) {
        return ObjectExpressionKeysTransformer_1.isReferencedIdentifierName(objectExpressionNode, hostStatement);
    }
    static isReferencedIdentifierName(objectExpressionNode, hostNode) {
        const identifierNamesSet = [];
        let isReferencedIdentifierName = false;
        let isCurrentNode = false;
        estraverse.traverse(hostNode, {
            enter: (node) => {
                if (node === objectExpressionNode) {
                    isCurrentNode = true;
                }
                if (!NodeGuards_1.NodeGuards.isIdentifierNode(node)) {
                    return;
                }
                if (!isCurrentNode) {
                    identifierNamesSet.push(node.name);
                    return;
                }
                if (identifierNamesSet.includes(node.name)) {
                    isReferencedIdentifierName = true;
                }
            },
            leave: (node) => {
                if (node === objectExpressionNode) {
                    isCurrentNode = false;
                    return estraverse.VisitorOption.Break;
                }
            }
        });
        return isReferencedIdentifierName;
    }
    getVisitor(transformationStage) {
        if (!this.options.transformObjectKeys) {
            return null;
        }
        switch (transformationStage) {
            case TransformationStage_1.TransformationStage.Converting:
                return {
                    leave: (node, parentNode) => {
                        if (parentNode
                            && NodeGuards_1.NodeGuards.isObjectExpressionNode(node)) {
                            return this.transformNode(node, parentNode);
                        }
                    }
                };
            default:
                return null;
        }
    }
    transformNode(objectExpressionNode, parentNode) {
        if (!objectExpressionNode.properties.length) {
            return objectExpressionNode;
        }
        const hostStatement = NodeStatementUtils_1.NodeStatementUtils.getRootStatementOfNode(objectExpressionNode);
        if (ObjectExpressionKeysTransformer_1.isProhibitedHostStatement(objectExpressionNode, hostStatement)) {
            return objectExpressionNode;
        }
        return this.applyObjectExpressionKeysExtractorsRecursive(ObjectExpressionKeysTransformer_1.objectExpressionExtractorNames, objectExpressionNode, hostStatement);
    }
    applyObjectExpressionKeysExtractorsRecursive(objectExpressionExtractorNames, objectExpressionNode, hostStatement) {
        const newObjectExpressionExtractorNames = [...objectExpressionExtractorNames];
        const objectExpressionExtractor = newObjectExpressionExtractorNames.shift();
        if (!objectExpressionExtractor) {
            return objectExpressionNode;
        }
        const { nodeToReplace, objectExpressionHostStatement: newObjectExpressionHostStatement, objectExpressionNode: newObjectExpressionNode } = this.objectExpressionExtractorFactory(objectExpressionExtractor)
            .extract(objectExpressionNode, hostStatement);
        this.applyObjectExpressionKeysExtractorsRecursive(newObjectExpressionExtractorNames, newObjectExpressionNode, newObjectExpressionHostStatement);
        return nodeToReplace;
    }
};
ObjectExpressionKeysTransformer.objectExpressionExtractorNames = [
    ObjectExpressionExtractor_1.ObjectExpressionExtractor.ObjectExpressionToVariableDeclarationExtractor,
    ObjectExpressionExtractor_1.ObjectExpressionExtractor.BasePropertiesExtractor
];
ObjectExpressionKeysTransformer = ObjectExpressionKeysTransformer_1 = __decorate([
    inversify_1.injectable(),
    __param(0, inversify_1.inject(ServiceIdentifiers_1.ServiceIdentifiers.Factory__IObjectExpressionExtractor)),
    __param(1, inversify_1.inject(ServiceIdentifiers_1.ServiceIdentifiers.IRandomGenerator)),
    __param(2, inversify_1.inject(ServiceIdentifiers_1.ServiceIdentifiers.IOptions)),
    __metadata("design:paramtypes", [Function, Object, Object])
], ObjectExpressionKeysTransformer);
exports.ObjectExpressionKeysTransformer = ObjectExpressionKeysTransformer;
